import React, { createContext, useContext, useState } from 'react';

const translations = {
  fr: {
    // Navigation
    nav_enquire: "Prendre Contact",
    
    // Hero
    hero_tagline: "Offrez-vous un art de vivre incomparable",
    hero_subtitle: "Villa Contemporaine d'Exception",
    hero_location: "Croissy-sur-Seine • Limite Le Vésinet & Chatou",
    hero_cta: "Découvrir",
    
    // Stats
    price: "2 495 000 €",
    stat_living: "320 m²",
    stat_living_label: "Habitable",
    stat_land: "1 063 m²",
    stat_land_label: "Terrain",
    stat_rooms: "10",
    stat_rooms_label: "Pièces",
    stat_bedrooms: "5",
    stat_bedrooms_label: "Chambres",
    
    // Introduction Section
    intro_title: "Un Havre de Paix",
    intro_text: "Véritable havre de paix, cette propriété d'exception se dresse sur près de 1 100 m² de terrain paysagé, agrémenté d'une piscine élégante, au cœur d'un hameau privé et sécurisé. Idéalement située à quelques pas de toutes les commodités : centre-ville animé, écoles réputées et gare RER accessibles à pied.",
    intro_highlight: "Pensée à la fois comme maison familiale et villa de réception, elle marie harmonieusement confort, luminosité et sécurité dans un environnement résidentiel exclusif.",
    
    // Gallery
    gallery_title: "Une Résidence d'Exception",
    gallery_subtitle: "À l'intérieur, laissez-vous séduire par cette demeure de plus de 340 m², baignée de lumière, répartie sur 10 pièces spacieuses pensées pour répondre à toutes vos envies.",
    
    // Ground Floor Section
    ground_floor_title: "Rez-de-Chaussée",
    ground_floor_reception: "Espace de réception",
    ground_floor_reception_desc: "Immense espace de réception de près de 100 m², inondé de lumière naturelle grâce à une hauteur sous plafond spectaculaire de plus de 3 mètres, prolongeant l'expérience de vie vers une vaste terrasse plein sud de 80 m² et la piscine.",
    ground_floor_master: "Suite Parentale",
    ground_floor_master_desc: "Suite parentale luxueuse de 32 m², avec grand dressing totalement équipé, ouverte sur une terrasse à l'est et le jardin. Salle de bain avec baignoire îlot, douche à l'italienne et double vasque.",
    ground_floor_office: "Bureau / Chambre",
    ground_floor_office_desc: "Deuxième chambre ou bureau de 16 m² avec rangements intégrés et salle d'eau privative.",
    
    // Garden Level Section
    garden_level_title: "Rez-de-Jardin",
    garden_level_subtitle: "Autour d'un patio lumineux de 32 m²",
    garden_level_lounge: "Grand Salon",
    garden_level_lounge_desc: "Espace salon de 33 m², parfait pour la détente.",
    garden_level_bedrooms: "Chambres Enfants",
    garden_level_bedrooms_desc: "Deux belles chambres de 17 et 19 m² avec grands placards, partageant une salle de bains familiale avec baignoire semi-îlot, double vasque et WC.",
    garden_level_cinema: "Home Cinéma",
    garden_level_cinema_desc: "Espace de 30 m² pour home cinéma, salle de sports ou de jeux.",
    garden_level_studio: "Studio Indépendant",
    garden_level_studio_desc: "Studio de 30 m² avec entrée privative, chambre avec placard, salle d'eau avec WC, kitchenette possible. Idéal pour invités ou personnel.",
    
    // Features
    features_title: "Prestations Haut de Gamme",
    features_subtitle: "Écologique et basse consommation (DPE A, normes RT2012), cette demeure vous garantit un confort absolu avec des matériaux haut de gamme et une conception moderne.",
    feature_pool: "Piscine Chauffée",
    feature_pool_desc: "4x8 m sécurisée par volet roulant automatique",
    feature_cinema: "Home Cinéma / Sports",
    feature_cinema_desc: "30 m² dédiés au divertissement",
    feature_garden: "Jardin Méditerranéen",
    feature_garden_desc: "Palmiers, oliviers, pelouse, arrosage automatique avec cuve 3000L",
    feature_domotics: "Domotique Intégrée",
    feature_domotics_desc: "Thermostat connecté, fibre optique, volets électriques",
    feature_terrace: "Terrasses",
    feature_terrace_desc: "3 terrasses spacieuses totalisant 125 m² en bambou Mosso",
    feature_height: "Volumes Exceptionnels",
    feature_height_desc: "Hauteur sous plafond ≥ 2,8 m, lumière naturelle abondante",
    feature_security: "Sécurité Premium",
    feature_security_desc: "Portail électrique, porte blindée, vidéophone, hameau privé",
    feature_heating: "Confort Thermique",
    feature_heating_desc: "Plancher chauffant basse température, climatisation réversible RDC",
    feature_fireplace: "Cheminée Contemporaine",
    feature_fireplace_desc: "Cheminée à bois avec récupérateur de chaleur",
    feature_bathroom: "Salles de Bains Luxueuses",
    feature_bathroom_desc: "2 salles de bains avec double vasque et baignoire îlot, 2 salles de douche, 4 WC",
    feature_studio: "Studio Indépendant",
    feature_studio_desc: "30 m² avec entrée privative, parfait pour invités",
    feature_pmr: "Accessibilité PMR",
    feature_pmr_desc: "Accès adapté aux personnes à mobilité réduite",
    
    // Location
    location_title: "Emplacement Privilégié",
    location_subtitle: "Une vie exclusive vous attend dans ce cadre d'exception : luminosité, volumes, tranquillité et raffinement.",
    location_paris: "30 min de Paris",
    location_paris_desc: "Gare RER accessible à pied",
    location_calm: "Hameau Privé",
    location_calm_desc: "Environnement résidentiel exclusif et sécurisé",
    location_amenities: "Toutes Commodités",
    location_amenities_desc: "Centre-ville commerçant, proximité écoles réputées (Lycée Alain, Le Bon Sauveur, British School, Lycée International)",
    location_nature: "Cadre Verdoyant",
    location_nature_desc: "Vue dégagée, parfaitement calme, jardin clos",
    
    // Floor Plans
    plans_title: "Plans Architecturaux",
    plans_subtitle: "Deux niveaux de vie pensés pour le confort et la réception",
    plans_ground: "Rez-de-Chaussée",
    plans_ground_desc: "Espace réception 100 m², Suite parentale 32 m², Bureau 16 m², Cuisine équipée",
    plans_garden: "Rez-de-Jardin",
    plans_garden_desc: "Salon 33 m², Home cinéma 30 m², Studio 30 m², 2 Chambres, Patio 32 m²",
    plans_download: "Télécharger les Plans (PDF)",
    
    // Closing
    closing_quote: "Découvrez un art de vivre rare, où chaque instant rime avec sérénité et distinction pour vous offrir la maison de vos rêves, à deux pas de Paris.",
    
    // Contact
    contact_title: "Organiser une Visite Privée",
    contact_subtitle: "Que vous soyez amateur de grands espaces lumineux ou en quête d'un environnement sécurisé à la pointe de la modernité, cette villa saura répondre à toutes vos attentes et même les dépasser.",
    contact_name: "Votre Nom",
    contact_email: "Votre Email",
    contact_phone: "Votre Téléphone",
    contact_message: "Votre Message",
    contact_send: "Envoyer",
    contact_direct: "Contact Direct Propriétaire",
    contact_or: "Ou",
    
    // Footer
    footer_address: "34 Ter rue de Verdun, Croissy-sur-Seine",
    footer_copyright: "© 2025 • Vente Privée"
  },
  en: {
    // Navigation
    nav_enquire: "Enquire Now",
    
    // Hero
    hero_tagline: "Experience an incomparable art of living",
    hero_subtitle: "Exceptional Contemporary Villa",
    hero_location: "Croissy-sur-Seine • Near Le Vésinet & Chatou",
    hero_cta: "Discover",
    
    // Stats
    price: "€2,495,000",
    stat_living: "320 m²",
    stat_living_label: "Living Space",
    stat_land: "1,063 m²",
    stat_land_label: "Land",
    stat_rooms: "10",
    stat_rooms_label: "Rooms",
    stat_bedrooms: "5",
    stat_bedrooms_label: "Bedrooms",
    
    // Introduction Section
    intro_title: "A Haven of Peace",
    intro_text: "A true haven of peace, this exceptional property stands on nearly 1,100 m² of landscaped grounds, featuring an elegant pool, in the heart of a private and secure hamlet. Ideally located just steps from all amenities: vibrant town center, renowned schools and RER station all within walking distance.",
    intro_highlight: "Designed as both a family home and an entertainment villa, it harmoniously combines comfort, luminosity and security in an exclusive residential environment.",
    
    // Gallery
    gallery_title: "An Exceptional Residence",
    gallery_subtitle: "Inside, be captivated by this residence of over 340 m², bathed in light, spread across 10 spacious rooms designed to meet your every desire.",
    
    // Ground Floor Section
    ground_floor_title: "Ground Floor",
    ground_floor_reception: "Reception Area",
    ground_floor_reception_desc: "Immense reception space of nearly 100 m², flooded with natural light thanks to a spectacular ceiling height of over 3 meters, extending the living experience to a vast south-facing terrace of 80 m² and the pool.",
    ground_floor_master: "Master Suite",
    ground_floor_master_desc: "Luxurious 32 m² master suite with fully equipped walk-in closet, opening onto an east-facing terrace and garden. Bathroom with freestanding tub, Italian shower and double vanity.",
    ground_floor_office: "Office / Bedroom",
    ground_floor_office_desc: "Second bedroom or office of 16 m² with built-in storage and private shower room.",
    
    // Garden Level Section
    garden_level_title: "Garden Level",
    garden_level_subtitle: "Around a bright 32 m² patio",
    garden_level_lounge: "Large Lounge",
    garden_level_lounge_desc: "33 m² lounge space, perfect for relaxation.",
    garden_level_bedrooms: "Children's Bedrooms",
    garden_level_bedrooms_desc: "Two beautiful bedrooms of 17 and 19 m² with large closets, sharing a family bathroom with semi-freestanding tub, double vanity and WC.",
    garden_level_cinema: "Home Cinema",
    garden_level_cinema_desc: "30 m² space for home cinema, gym or games room.",
    garden_level_studio: "Independent Studio",
    garden_level_studio_desc: "30 m² studio with private entrance, bedroom with closet, bathroom with WC, kitchenette possible. Ideal for guests or staff.",
    
    // Features
    features_title: "Premium Amenities",
    features_subtitle: "Eco-friendly and low consumption (DPE A, RT2012 standards), this residence guarantees absolute comfort with high-end materials and modern design.",
    feature_pool: "Heated Pool",
    feature_pool_desc: "4x8 m secured with automatic roller shutter",
    feature_cinema: "Home Cinema / Gym",
    feature_cinema_desc: "30 m² dedicated to entertainment",
    feature_garden: "Mediterranean Garden",
    feature_garden_desc: "Palm trees, olive trees, lawn, automatic irrigation with 3000L tank",
    feature_domotics: "Smart Home",
    feature_domotics_desc: "Connected thermostat, fiber optics, electric shutters",
    feature_terrace: "Terraces",
    feature_terrace_desc: "3 spacious terraces totaling 125 m² in Mosso bamboo",
    feature_height: "Exceptional Volumes",
    feature_height_desc: "Ceiling height ≥ 2.8 m, abundant natural light",
    feature_security: "Premium Security",
    feature_security_desc: "Electric gate, armored door, video intercom, private hamlet",
    feature_heating: "Thermal Comfort",
    feature_heating_desc: "Low temperature underfloor heating, reversible AC on ground floor",
    feature_fireplace: "Contemporary Fireplace",
    feature_fireplace_desc: "Wood fireplace with heat recovery system",
    feature_bathroom: "Luxurious Bathrooms",
    feature_bathroom_desc: "2 bathrooms with double vanity and freestanding tub, 2 shower rooms, 4 WC",
    feature_studio: "Independent Studio",
    feature_studio_desc: "30 m² with private entrance, perfect for guests",
    feature_pmr: "PMR Accessibility",
    feature_pmr_desc: "Adapted access for persons with reduced mobility",
    
    // Location
    location_title: "Prime Location",
    location_subtitle: "An exclusive life awaits you in this exceptional setting: luminosity, volumes, tranquility and refinement.",
    location_paris: "30 min from Paris",
    location_paris_desc: "RER station within walking distance",
    location_calm: "Private Hamlet",
    location_calm_desc: "Exclusive and secure residential environment",
    location_amenities: "All Amenities",
    location_amenities_desc: "Shopping district, near renowned schools (Lycée Alain, Le Bon Sauveur, British School, Lycée International)",
    location_nature: "Green Setting",
    location_nature_desc: "Open views, perfectly quiet, enclosed garden",
    
    // Floor Plans
    plans_title: "Architectural Plans",
    plans_subtitle: "Two levels of living designed for comfort and entertainment",
    plans_ground: "Ground Floor",
    plans_ground_desc: "Reception 100 m², Master suite 32 m², Office 16 m², Equipped kitchen",
    plans_garden: "Garden Level",
    plans_garden_desc: "Lounge 33 m², Home cinema 30 m², Studio 30 m², 2 Bedrooms, Patio 32 m²",
    plans_download: "Download Plans (PDF)",
    
    // Closing
    closing_quote: "Discover a rare art of living, where every moment rhymes with serenity and distinction, offering you your dream home, just steps from Paris.",
    
    // Contact
    contact_title: "Arrange a Private Viewing",
    contact_subtitle: "Whether you are a lover of large luminous spaces or seeking a secure environment at the cutting edge of modernity, this villa will meet all your expectations and even exceed them.",
    contact_name: "Your Name",
    contact_email: "Your Email",
    contact_phone: "Your Phone",
    contact_message: "Your Message",
    contact_send: "Send",
    contact_direct: "Direct Owner Contact",
    contact_or: "Or",
    
    // Footer
    footer_address: "34 Ter rue de Verdun, Croissy-sur-Seine",
    footer_copyright: "© 2025 • Private Sale"
  }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('fr');
  
  const t = (key) => translations[language][key] || key;
  
  const toggleLanguage = () => {
    setLanguage(prev => prev === 'fr' ? 'en' : 'fr');
  };
  
  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
